import Backbone from 'backbone';

export default Backbone.Collection.extend({

  isModelValid(model) {
    return model.isValid();
  },

  loadPage(page, size) {
    return this.fetchMatching(
      (page - 1) * size,
      size,
      this.isModelValid,
    );
  },

  fetchAllMatching() {
    return this.fetchMatching(
      0,
      this.models.length,
      this.isModelValid,
    );
  },

  fetchMatching(start, end, match) {
    let promiseFulfill;
    let promiseReject;
    const promise = new Promise(((fulfill, reject) => {
      promiseFulfill = fulfill;
      promiseReject = reject;
    }));
    let count = end;
    const result = [];
    const self = this;
    const loaded = [];
    const queue = this.models.slice(start);

    if (queue.length === 0) {
      promiseReject();
    }

    const compare = (a, b) => (self.indexOf(a) - self.indexOf(b));

    const handler = (model, info) => {
      model.set('loaded', true);

      if (!match.call(model, model)) {
        // remove model from collection if
        // it isn't matching
        self.remove(model);

        if (queue.length) {
          // eslint-disable-next-line no-use-before-define
          fetch(queue.shift());
          return;
        }

        count -= 1;
      } else {
      //  model.attributes.product.detail.name = self.counter++;
        result.push(model);
        if (info) {
          loaded.push(model);
        }
      }

      if (result.length === count) {
        // return loaded thumbs in the same order
        // as they presented in collection
        result.sort(compare);
        loaded.sort(compare);

        promiseFulfill(result, loaded);

        self.trigger('fetch:done', result, loaded);
      }
    };
    // eslint-disable-next-line no-use-before-define
    const fetch = (model) => {
      model.fetch({
        success: handler,
        error: handler,
      });
    };

    if (count > queue.length) {
      count = queue.length;
    }


    queue.splice(0, count).forEach((model) => {
      if (model.get('loaded')) {
        handler(model);
      } else {
        fetch(model);
      }
    });

    return promise;
  },

}, {

  fromArray(ids, options, properties) {
    const models = ids.map((item, index) => ({
      id: item.id,
      choiceId: item.choiceId,
      index,
      clickTrackingUrl: item.clickTrackingUrl || '',
      content: options.content,
      upcs: item.upcs,
      displayUpcImage: item.displayUpcImage,
      imageWidth: options.imageWidth,
      carouselOrientation: options.orientation,
      properties,
      colorName: item.colorName,
      images: item.images,
      zone: options.zone,
    }));

    return new this(models, options);
  },

});
